import React, { useEffect, useRef, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faVideo } from '@fortawesome/pro-regular-svg-icons/faVideo'

// Matches the storefront's mobile breakpoint
const MOBILE_QUERY = '(max-width: 991px)'

let Icon = () => (
    <div className="flex items-center justify-center w-full py-10">
        <FontAwesomeIcon icon={faVideo} size="6x" />
    </div>
)

const useIsMobile = () => {
    const [isMobile, setIsMobile] = useState(
        () => typeof window !== 'undefined' && window.matchMedia(MOBILE_QUERY).matches
    )

    useEffect(() => {
        const mediaQuery = window.matchMedia(MOBILE_QUERY)
        const onChange = e => setIsMobile(e.matches)

        mediaQuery.addListener(onChange)
        return () => mediaQuery.removeListener(onChange)
    }, [])

    return isMobile
}

const VideoRenderer = ({ state = {}, remove = false }) => {
    const {
        url = '',
        poster = '',
        autoPlay = false,
        loop = false,
        controls = false,
        showControlsOnHover = false,
        muted = false,
        playsInline = false,
    } = state

    const videoRef = useRef(null)
    const [isHovered, setIsHovered] = useState(false)
    const isMobile = useIsMobile()

    const isInLibraryBlock = typeof remove != 'function'
    const inStorefront = !window?.location?.pathname.includes('/content/edit/')

    // Browsers only allow muted videos to autoplay, and iOS also requires playsinline
    const isMuted = autoPlay || muted || isInLibraryBlock
    const isPlaysInline = autoPlay || playsInline

    useEffect(() => {
        const video = videoRef.current
        if (!video) return

        // React doesn't reliably reflect the muted prop to the element, which blocks autoplay
        video.muted = isMuted

        if (autoPlay) {
            // play() returns a promise that rejects if the browser still blocks autoplay
            const playPromise = video.play()

            if (playPromise !== undefined) {
                playPromise.catch(() => {})
            }
        }
    }, [autoPlay, isMuted, url])

    if (!url) {
        return inStorefront ? null : <Icon />
    }

    const showControls = controls || (showControlsOnHover && (isMobile || isHovered))

    return (
        <div
            className="content__video"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <video
                ref={videoRef}
                style={{ width: '100%' }}
                src={url}
                poster={poster || undefined}
                autoPlay={autoPlay}
                loop={loop}
                muted={isMuted}
                playsInline={isPlaysInline}
                controls={showControls}
                preload={autoPlay ? 'auto' : 'metadata'}
            />
        </div>
    )
}

export default VideoRenderer
